import React from 'react';
import { UserIcon, BuildingOfficeIcon, BriefcaseIcon } from '@heroicons/react/24/solid'; // Updated icons

const features = [
  {
    name: 'Parents/Carers',
    icon: UserIcon,
    points: [
      'Access to a map of services across the UK',
      'Use your local authority funding to easily book through our system',
      'Communicate directly with providers through our messaging system',
      'Access a range of SEND tools, support aids, and guidance, all downloadable to share with your network',
      'Leave reviews on products and services and find out what our community thinks',
      'Regular blogs on all things SEND and guest blog features',
      'Webinars and videos on hot topics, how-to guides, and SEND experience and knowledge',
      'Personalised support based on your child’s age and needs',
      'Exclusive discounts and offers',
    ]
    
  },
  {
    name: 'Local Authorities',
    icon: BuildingOfficeIcon,
    points: [
      'Oversee your SEND support packages',
      'Access to a map of services across the UK',
      'Communicate directly with parents/carers and services',
      'Access a range of SEND tools, support aids, and guidance, all downloadable to share with your network',
      'Regular blogs on all things SEND and guest blog features',
      'Webinars and videos on hot topics, how-to guides, and SEND experience and knowledge',
      'Consultancy',
      'Training and workshops',
      'Ability to report on your users and services purchased',
    ]
    
  },
  {
    name: 'Providers',
    icon: BriefcaseIcon,
    points:[
      'Receive and manage bookings through our in-house system',
      'Receive payments directly for your services',
      'Advertise on our map',
      'Communicate directly with parents/carers with ease',
      'Access a range of SEND tools, support aids, and guidance, all downloadable to share with your network',
      'Regular blogs on all things SEND and guest blog features',
      'Webinars and videos on hot topics, how-to guides, and SEND experience and knowledge',
      'Consultancy',
      'Training and workshops',
    ]
    
  },
];

export default function Feature() {
  return (
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-base/7 font-semibold text-blue-600">Empowering SEND connections</h2>
          <p className="mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl lg:text-balance">
            Why enableSEND?
          </p>
          <p className="mt-6 text-lg/8 text-gray-600">
          enableSEND has created an app that supports families, local authorities, and providers. See below some of what we have to offer.          </p>
        </div>
        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
          <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
            {features.map((feature) => (
              <div key={feature.name} className="flex flex-col">
                <dt className="flex items-center gap-x-3 text-base/7 font-semibold text-gray-900">
                  <feature.icon aria-hidden="true" className="h-5 w-5 flex-none text-blue-600" />
                  {feature.name}
                </dt>
                <dd className="mt-4 flex-auto text-base/7 text-gray-600">
                  <ul className="list-disc pl-5 space-y-2">
                    {feature.points.map((point, index) => (
                      <li key={index}>{point}</li>
                    ))}
                  </ul>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
